import React, { useCallback } from 'react'

import {
  AttentionFilled,
  Button,
  Icon,
  TextInput,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string } from 'prop-types'

import { ERROR_MESSAGES } from '../../constants'

function EmailForm({
  email, error = null, needsSignIn, isSubmitting, onEmailChange, onSubmit,
}) {
  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      onSubmit()
    }
  }, [onSubmit])

  return (
    <div className="conference-sign-in-modal__form">
      <TextInput
        id="conference-sign-in-email"
        type="primary"
        size="medium"
        placeholder="Enter your email address"
        value={email}
        onChange={onEmailChange}
        onKeyDown={handleKeyDown}
        isDisabled={isSubmitting}
        isWarning={!!error}
        textInputClassName="conference-sign-in-modal__input"
        aria-label="Email address"
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? 'conference-sign-in-error' : undefined}
        autoFocus
        isPilot
      />

      {error && (
        <div className="conference-sign-in-modal__error-row">
          <Icon color="warning" notSpaced size="small" svgComponent={AttentionFilled} />
          <p
            id="conference-sign-in-error"
            className="conference-sign-in-modal__error cgt-body-base"
            role="alert"
          >
            {error}
          </p>
        </div>
      )}

      {needsSignIn && (
        <div className="conference-sign-in-modal__notice">
          <p className="cgt-body-base">
            {ERROR_MESSAGES.needs_sign_in}
          </p>
          <a
            className="cgt-link-primary-accented"
            href={`/users/sign_in?email=${encodeURIComponent(email.trim())}`}
          >
            Sign in to your account
          </a>
        </div>
      )}

      <Button
        type="primary"
        size="medium"
        onClick={onSubmit}
        disabled={isSubmitting || !email.trim()}
        customClass="conference-sign-in-modal__submit"
      >
        {isSubmitting ? 'Signing you in...' : 'Start Generating'}
      </Button>
    </div>
  )
}

EmailForm.propTypes = {
  email: string.isRequired,
  error: string,
  needsSignIn: bool.isRequired,
  isSubmitting: bool.isRequired,
  onEmailChange: func.isRequired,
  onSubmit: func.isRequired,
}

export default EmailForm
